import * as React from 'react'
import { GLOBAL_SETTINGS_MOBILITY_DEVICES_COLUMN } from '../../state/constants/index'
import { IMobilityOptionObject, IMobilityOptionCategoryObject } from '../../types/index'
import MobilityDevicesListItem from './MobilityDevicesListItem'

interface IGlobalSettingsMobilityDevicesListProps {
  devices: IMobilityOptionObject[]
  categories: IMobilityOptionCategoryObject[]
  columns: GLOBAL_SETTINGS_MOBILITY_DEVICES_COLUMN[]
  getMobilityOptions: () => Promise<any>
  getMobilityOptionCategories: () => Promise<any>
}

class MobilityDevicesList extends React.Component<IGlobalSettingsMobilityDevicesListProps> {
  constructor(props: any) {
    super(props)
  }

  public componentDidMount() {
    this.props.getMobilityOptionCategories()
    this.props.getMobilityOptions()
  }

  public render() {
    if (!this.props.devices || !this.props.categories) {
      return null
    }

    return (
      <div>
        {Object.values(this.props.devices).map((it: IMobilityOptionObject) => (
          <MobilityDevicesListItem
            categories={this.props.categories}
            device={it}
            key={`mobility-device-item-${it.id}`}
          />
        ))}
      </div>
    )
  }
}

export default MobilityDevicesList



// WEBPACK FOOTER //
// ./src/components/global-settings/MobilityDevicesList.tsx